import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="w-full bg-cream py-20 px-6" data-id="element-91">
      <div className="max-w-3xl mx-auto text-center" data-id="element-92">
        <FadeIn data-id="element-93">
          <span className="text-gold font-bold tracking-wider uppercase text-sm md:text-base mb-4 block" data-id="element-94">
            El Descubrimiento
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-95">
            El Interruptor de Combustible Estrógeno-Independiente (ICE-I)
          </h2>

          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl text-left relative overflow-hidden" data-id="element-96">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-bl-full -z-10" data-id="element-97"></div>

            <p className="text-lg text-charcoal mb-6 leading-relaxed" data-id="element-98">
              Este protocolo activa una vía alterna de combustible que tu
              cerebro tiene de respaldo.
            </p>
            <p className="text-lg text-charcoal mb-6 leading-relaxed" data-id="element-99">
              En lugar de depender del estrógeno para procesar glucosa, le
              enseñamos a tu cuerpo a usar{' '}
              <strong className="text-sage" data-id="element-100">
                Cetonas y Polifenoles de activación inmediata
              </strong>
              .
            </p>
            <div className="bg-cream-dark p-6 rounded-xl border-l-4 border-gold" data-id="element-101">
              <p className="text-lg font-medium text-sage-dark m-0 italic" data-id="element-102">
                "Es como instalar un generador de emergencia que mantiene las
                luces encendidas y tu mente rápida, sin importar tus niveles
                hormonales."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}